import getConfig from 'next/config';

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();

const {
  BASE_PATH,
  COMMIT_SHA,
  GOOGLE_TAG_MANAGER_ID,
  LD_CLIENT_ID,
  LD_RELAY_SERVICE_URL,
  NODE_ENV,
  RECAPTCHA_SITE_KEY,
  SENTRY_DSN,
  IS_STAGING,
  REGION,
  SAUCE_API_URL,
}: {
  BASE_PATH: string;
  COMMIT_SHA: string;
  GOOGLE_TAG_MANAGER_ID: string;
  LD_CLIENT_ID: string;
  LD_RELAY_SERVICE_URL: string;
  NODE_ENV: string;
  RECAPTCHA_SITE_KEY: string;
  SENTRY_DSN: string;
  IS_STAGING: boolean;
  REGION: string;
  SAUCE_API_URL: string;
} = publicRuntimeConfig;

const IS_SERVER: boolean = Object.keys(serverRuntimeConfig).length > 0;

export {
  BASE_PATH,
  COMMIT_SHA,
  GOOGLE_TAG_MANAGER_ID,
  IS_SERVER,
  LD_CLIENT_ID,
  LD_RELAY_SERVICE_URL,
  NODE_ENV,
  RECAPTCHA_SITE_KEY,
  SENTRY_DSN,
  IS_STAGING,
  REGION,
  SAUCE_API_URL,
};
